import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import { FormatListBulletedOutlined, GridViewOutlined } from "@mui-symbols-material/w300"
import type { ReactNode } from "react"

import { ListMode } from "@/types/common"

const ListModeToggle = ({
  listMode,
  onChange,
}: {
  listMode: ListMode
  onChange: (listMode: ListMode) => void
}): ReactNode => {
  const buttonStyle = {
    "&.Mui-selected": {
      backgroundColor: "#d2e3f3",
      color: "#0f5392",
      "&:hover": {
        backgroundColor: "#d2e3f3",
      },
    },
  }

  return (
    <ToggleButtonGroup
      value={listMode}
      exclusive
      onChange={(_, mode) => {
        if (!mode) return
        onChange(mode)
      }}
    >
      <ToggleButton value={ListMode.CARDS} sx={buttonStyle} size='small'>
        <GridViewOutlined />
      </ToggleButton>
      <ToggleButton value={ListMode.TABLE} sx={buttonStyle} size='small'>
        <FormatListBulletedOutlined />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default ListModeToggle
